import { render, staticRenderFns } from "./OmnibusTransactionCodeManagement.vue?vue&type=template&id=7ca4efca&scoped=true"
import script from "./OmnibusTransactionCodeManagement.vue?vue&type=script&lang=ts"
export * from "./OmnibusTransactionCodeManagement.vue?vue&type=script&lang=ts"
import style0 from "./OmnibusTransactionCodeManagement.vue?vue&type=style&index=0&id=7ca4efca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ca4efca",
  null
  
)

export default component.exports